
import PaginationV2 from '@/components/ui/Pagination-V2.vue';
import { constants, IsUserSearchEventAt } from '@/config/constant.config';
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import swal from '../../helper/swal.helper';
import CrudModel from '../../models/jinCategories.model';

export default defineComponent({
  name: 'JinCategories',
  props: {},
  components: {
    PaginationV2,
  },
  setup: () => {
    const router = useRouter();
    const route = useRoute();
    const userSearchEventFlag = ref<IsUserSearchEventAt>(IsUserSearchEventAt.N);
    const categories = ref<any[]>([]);
    const perpage = constants().DEFAULT_PERPAGE;
    const loading = ref(false);
    const orderOptions = ref([[]]);
    const filterConditions = ref<Array<any>>([]);
    function updateData(items: any[]) {
      loading.value = false;
      categories.value = items;
    }
    function isLoading(status: boolean) {
      loading.value = status;
    }

    const addRecord = () => {
      router.push({
        path: '/jin-categories/add',
        query: route.query,
      });
    };

    async function editRecord(id: any) {
      router.push(`/jin-categories/edit/${id}`);
    }
    async function deleteRecord(id: any) {
      swal.simpleDeleteConfirm(async () => {
        loading.value = true;
        await CrudModel.delete(id);
        categories.value = await CrudModel.getAll();
        loading.value = false;
        await searchHandler();
      });
    }
    async function searchHandler() {
      if (userSearchEventFlag.value === IsUserSearchEventAt.Y) {
        route.query.page = '1';
      }
      filterConditions.value = [];
    }

    onMounted(async () => {
      await searchHandler();
    });

    return {
      categories,
      loading,
      orderOptions,
      perpage,
      filterConditions,
      addRecord,
      updateData,
      isLoading,
      CrudModel,
      deleteRecord,
      editRecord,
    };
  },
});
